import { render, staticRenderFns } from "./LicenseRow.vue?vue&type=template&id=64e49384&scoped=true&"
import script from "./LicenseRow.vue?vue&type=script&lang=ts&"
export * from "./LicenseRow.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseRow.vue?vue&type=style&index=0&id=64e49384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e49384",
  null
  
)

export default component.exports